/**
 * Copia texto para a área de transferência com fallback automático.
 *
 * Em alguns navegadores móveis (especialmente iOS antigos, WebView dentro
 * de apps, ou contextos sem HTTPS), `navigator.clipboard.writeText` lança
 * um DOMException. Este helper trata isso de forma silenciosa e tenta
 * múltiplas estratégias antes de desistir.
 *
 * @param {string} text Texto a copiar
 * @returns {Promise<boolean>} true se copiou com sucesso
 */
export async function copyToClipboard(text) {
  const value = String(text ?? "");
  if (!value) return false;
  // Estratégia 1: Clipboard API moderna (precisa de HTTPS/contexto seguro)
  try {
    if (navigator?.clipboard?.writeText) {
      await navigator.clipboard.writeText(value);
      return true;
    }
  } catch {
    /* tenta fallback */
  }
  // Estratégia 2: textarea + document.execCommand (legacy, mas funciona em mais lugares)
  try {
    const ta = document.createElement("textarea");
    ta.value = value;
    ta.style.position = "fixed";
    ta.style.top = "-9999px";
    ta.style.left = "-9999px";
    ta.style.opacity = "0";
    ta.setAttribute("readonly", "");
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    ta.setSelectionRange(0, value.length);
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return !!ok;
  } catch {
    return false;
  }
}
